import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import Checkbox from '../Checkbox/Checkbox';
import Cover from './Cover';
import Icon from '../Icon/Icon';
import Progressbar from '../Progressbar/Progressbar';

const FIELDS = [
  {
    name: 'created',
    value: '2017-01-10 09:17:00',
  }, {
    name: 'last updated',
    value: '2017-01-11 11:30:12',
  }, {
    name: 'duration',
    value: '00:00:00',
  }, {
    name: 'Transcoding',
    value: <Progressbar value={75}/>
  }, {
    name: 'Checkboxed',
    value: <Checkbox checked readOnly/>
  }, {
    name: 'published',
    value: true,
  }
];
const FIELDS2 = FIELDS.slice();
FIELDS2[4] = { ...FIELDS[4], value: <Checkbox readOnly/> };
FIELDS2[5] = { ...FIELDS[5], value: false };
const BADGES = [
  <Icon name="warning" key="warning" className="warning" title="Asset is not published"/>,
];

export default class CoverExample extends Component {

  state = {
    badgeNames: ['link'],
    cover: 'https://images.unsplash.com/photo-1455295299322-3aba0ba23ea3',
    id: '1OxGJDErKywB',
    title: 'Vimond Media Solutions',
    fields: FIELDS,
    tag: 'Draft',
    showVideo: false,
  };

  onChange = e => this.setState(e.target.value);

  onUseVideoCover = () => this.setState({ showVideo: !this.state.showVideo });

  render() {
    const { showVideo } = this.state;
    const cover = !showVideo ? this.state.cover : (
      <video height="224" controls autoPlay>
        <source src="http://clips.vorwaerts-gmbh.de/VfE_html5.mp4" type="video/mp4"/>
        <source src="http://clips.vorwaerts-gmbh.de/VfE.webm" type="video/webm"/>
        <source src="http://clips.vorwaerts-gmbh.de/VfE.ogv" type="video/ogg"/>
      </video>
    );

    return (
      <Example {...this.props}>
        <Properties onChange={this.onChange} defaultProps={Cover.defaultProps} propTypes={Cover.propTypes} propValues={this.state}/>
        <Cover {...this.state} fields={FIELDS2} badges={BADGES} cover={cover}/>
        <Checkbox label="Use custom cover art (video)" checked={this.state.showVideo} onChange={this.onUseVideoCover}/>
        <SourceCode querySelector=".core-cover"/>
      </Example>
    );
  }

}
